import sl from "../../../../components/startups-landing/startups-landing-sections.module.css"
import textStyles from "../../../../shared/styles/section-text.module.css"
import buildProfileStyles from "../build-profile/build-profile.module.css"
import KateFindWorkDemo from "./KateFindWorkDemo"
import styles from "./find-work.module.css"

const BULLETS = [
	"Tell Kate your ideal role in plain language. No forms.",
	"Matched to companies based on your real skills",
	"Kate handles the first reach-out on your behalf",
	"New matches delivered as the network grows",
	"One conversation replaces dozens of applications",
]

const FindWork = () => {
	return (
		<section id="find-work" className={`${buildProfileStyles.section} ${styles.section}`}>
			<div className={`container ${sl.sectionContainer}`}>
				<div className={styles.split}>
					<div className={styles.copy}>
						<header className={styles.sectionHeader}>
							<div className={sl.label}>Find Work</div>
							<h2 className={styles.title}>
								<span className={styles.titleLine}>The right roles find you.</span>
							</h2>
							<p className={`${sl.bodyLg} ${textStyles.regularDescription} ${styles.lead}`}>
								Kate searches the Techcore Network, a curated pool of growing companies actively hiring, and matches
								you based on your profile, skills, and what you're actually looking for. No job boards. No cold
								applying. Just relevant opportunities, delivered.
							</p>
						</header>
						<ul className={sl.featureChecklist}>
							{BULLETS.map((line) => (
								<li key={line}>{line}</li>
							))}
						</ul>
					</div>
					<div className={styles.artWrap}>
						<KateFindWorkDemo />
					</div>
				</div>
			</div>
		</section>
	)
}

export default FindWork
